import { render, staticRenderFns } from "./sleep-period-unit.vue?vue&type=template&id=3641ac52&scoped=true"
import script from "./sleep-period-unit.vue?vue&type=script&lang=js"
export * from "./sleep-period-unit.vue?vue&type=script&lang=js"
import style0 from "./sleep-period-unit.vue?vue&type=style&index=0&id=3641ac52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641ac52",
  null
  
)

export default component.exports